import { render, staticRenderFns } from "./searchdetail.vue?vue&type=template&id=6d9484a4&scoped=true&"
import script from "./searchdetail.vue?vue&type=script&lang=js&"
export * from "./searchdetail.vue?vue&type=script&lang=js&"
import style1 from "./searchdetail.vue?vue&type=style&index=1&id=6d9484a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9484a4",
  null
  
)

export default component.exports